import { NextPage } from 'next'
import React from 'react'

import AccountLayout from '../../components/layouts/account-layout'
import UnsubscribeDirect from '../../components/unsubscribe/unsubscribe-direct'

const UnsubscribeDirectPage: NextPage = () => {
  return (
    <AccountLayout pageId={'unsubscribe-direct-page'}>
      <UnsubscribeDirect />
    </AccountLayout>
  )
}

export default UnsubscribeDirectPage
